import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";
import PrimaryButton from "../ui/buttons/primaryButton";

import CloseIcon from "@mui/icons-material/Close";
import Form from "../ui/forms";
import Input from "../ui/forms/fields/input";

import { yupResolver } from "@hookform/resolvers/yup";
import { IconButton, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { sendSpeakToAConsultant } from "../../features/speakToAConsultant/speakToAConsultant.slice";
import { Report } from "../../libs/loggers";
import CheckboxList from "../ui/forms/fields/checkboxGroup";
import OrangeCircularProgress from "../ui/progress/circularProgress";

function ContactConsultant({
  title,
  subTitle,
  open,
  onClose,
  data,
  setCloseSpeakToConsultant,
}) {
  const [alertOpen, setAlertOpen] = useState(false);

  const dispatch = useDispatch();
  const notificationSuccess = useSelector(
    (state) =>
      state.notification.notification.speakToConsultantNotificationSuccess
  );
  const loading = useSelector(
    (state) => state.notification.notification.loading
  );

  const investVehicles = useSelector(
    (state) => state.investVehicle.value.vehicles
  );
  let page = window.location.pathname.replace(/^\/|\/$/g, "");
  const selectedVehicle = useSelector((state) => state.data.value.vehicle);
  const stepper = useSelector((state) => state.stepper.value);
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );
  const userId = useSelector((state) => state.submition.data?.userId);

  const validationSchema = yup.object().shape({
    name: yup.string().required("Name is required"),
    surname: yup.string().required("Surname is required"),
    email: yup.string().required("Email is required"),
    phone: yup.string().required("Phone is required"),
    products: yup.array().required("Products is required"),
    message: yup.string(),
  });

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(validationSchema),
  });

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const onFormSubmit = () => {
    handleSubmit(onSubmit)();
  };
  const onSubmit = async (formData) => {
    const newObj = { ...formData };
    delete newObj.name;
    delete newObj.surname;
    delete newObj.email;
    delete newObj.phone;

    setAlertOpen(true);
    const eventInfo = {
      action: "submit",
      category: "help",
      description: "clicked submit on speak to a consultant dialog",
      value: {
        ...newObj,
        currentPage: page,
        step: stepper.active + 1,
        value: `speak_to_a_consultant`,
      },
    };

    Report(eventInfo, userId, submitionId);

    await dispatch(sendSpeakToAConsultant({ ...formData, data }));

    reset();
    setCloseSpeakToConsultant();
  };

  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>
          {title}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {subTitle}
          <Form>
            <Input
              {...register("name")}
              label="Name"
              error={!!errors.name}
              helperText={errors?.name?.message}
            />
            <Input
              {...register("surname")}
              label="Surname"
              error={!!errors.surname}
              helperText={errors?.surname?.message}
            />
            <Input
              {...register("email")}
              label="Email"
              error={!!errors.email}
              helperText={errors?.email?.message}
            />
            <Input
              {...register("phone")}
              label="Phone"
              error={!!errors.phone}
              helperText={errors?.phone?.message}
            />
            {selectedVehicle && selectedVehicle.length > 0 && (
              <CheckboxList
                name="products"
                label="Products"
                control={control}
                options={investVehicles.map((vehicle) => ({
                  value: vehicle.name,
                  text: vehicle.name,
                }))}
                extraOptions={[
                  { value: "I am not sure", text: "I am not sure" },
                ]}
                defaultValue={[selectedVehicle]}
              />
            )}
            <Input
              {...register("message")}
              label="Any Comments or Questions"
              multiline
              rows={3}
              error={!!errors.message}
              helperText={errors?.message?.message}
            />
          </Form>
        </DialogContent>
        <DialogActions>
          <PrimaryButton onClick={onClose}>Cancel</PrimaryButton>
          <PrimaryButton onClick={onFormSubmit}>Submit</PrimaryButton>
        </DialogActions>
      </Dialog>
      <Dialog open={alertOpen} onClose={handleAlertClose}>
        <DialogTitle>
          {loading ? "Sending Request.." : "Speak to consultant."}
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <OrangeCircularProgress caption={"Sending Request"} />
          ) : notificationSuccess ? (
            <Typography>
              We have received your query and will get back to you soon.
            </Typography>
          ) : (
            <Typography>
              Something went wrong, please try again later.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <PrimaryButton onClick={handleAlertClose}>Close</PrimaryButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ContactConsultant;
